define('CustomPLP.AddToCart.View', [
    'Backbone',
    'LiveOrder.Model',
    'Configuration',
    'customplp_add_to_cart.tpl'
], function (
    Backbone,
    LiveOrderModel,
    Configuration,
    customplp_add_to_cart_tpl
) {
    'use strict';

    // Same Item Option id ArtworkUpload.EntryPoint.js's addLine guard checks
    // for. This view builds its own plain `line` object by hand and only
    // ever populated custcol20/custcol290 on it - that guard only sees what's
    // actually present in `line.options`, so an item requiring artwork
    // slipped through here with no option entry for it to find at all.
    var ARTWORK_CONFIG = Configuration.ArtworkUpload || {};
    var ARTWORK_CART_OPTION_ID = ARTWORK_CONFIG.cartOptionId || 'custcol_artwork_file';

    return Backbone.View.extend({
        template: customplp_add_to_cart_tpl,

        events: {
            'click [data-action="custom-add-to-cart"]': 'addToCart',
            'change .product-gobo-size': 'updateGoboSize',
            'input .product-light-fixture': 'updateLightFixture',
            'change .product_qty': 'updateQuantity'
        },

        initialize: function (options) {
            this.application = options.application;
            this.model = options.model;
            this.state = {
                isLoading: false,
                message: '',
                quantity: 1,
                errorMessage: '',
                lightFixture: '',
                goboSize: '',
                errorFields: {
                    goboSize: false,
                    lightFixture: false
                }
            };
            this.render();
        },

        updateGoboSize: function (e) {
            this.state.goboSize = (this.$(e.currentTarget).val() || '').toString().trim();
            this.state.errorFields.goboSize = false;
            this.$('.product-gobo-size').parent().removeAttr('data-validation-error');
        },

        updateLightFixture: function (e) {
            this.state.lightFixture = (this.$(e.currentTarget).val() || '').toString().trim();
            this.state.errorFields.lightFixture = false;
            this.$('.product-light-fixture').parent().removeAttr('data-validation-error');
        },

        updateQuantity: function (e) {
            var qty = parseInt(this.$(e.currentTarget).val(), 10) || 1;
            this.state.quantity = qty;
        },

        // @method hasArtworkOption Whether this item has the artwork Item
        // Option configured at all - this view has no file upload UI, so
        // this item can never be completed from here regardless of what
        // Gobo Size/Light Fixture are filled in.
        hasArtworkOption: function () {
            if (!this.model) return false;
            var itemOptions = this.model.get('options');
            return !!(itemOptions && itemOptions.find(function (option) {
                return option.attributes && option.attributes.cartOptionId === ARTWORK_CART_OPTION_ID;
            }));
        },

        addToCart: function (e) {
            e.preventDefault();

            var lightFixtureContainer = this.$('.product-light-fixture');
            var goboSizeContainer = this.$('.product-gobo-size');

            if (this.state.isLoading || !this.model) return;

            var requiresArtwork = this.hasArtworkOption();

            // Variables to determine whether or not the options are available, and if so, if they are selected
            var hasLFContainer = !!(lightFixtureContainer && lightFixtureContainer.length);
            var hasGSContainer = !!(goboSizeContainer && goboSizeContainer.length);

            var lfVal = hasLFContainer ? (lightFixtureContainer.val() || '').toString().trim() : null;
            var gsVal = hasGSContainer ? (goboSizeContainer.val() || '').toString().trim() : null;

            // Both controls are rendered disabled when the item requires
            // artwork (see getContext/template), so there's nothing
            // meaningful to validate here - skip straight to addLine, which
            // the ArtworkUpload guard will reject with its own message.
            if (!requiresArtwork && (hasLFContainer || hasGSContainer)) {
                var missingLF = hasLFContainer && !lfVal;
                var missingGS = hasGSContainer && !gsVal;

                if (missingLF || missingGS) {
                    this.state.errorMessage = "Please select Gobo Size and Light Fixture."
                    this.state.errorFields.lightFixture = missingLF;
                    this.state.errorFields.goboSize = missingGS;
                    this.render();
                    return;
                }
            }

            var self = this;
            this.state.isLoading = true;
            this.state.message = '';
            this.state.errorMessage = '';
            var $button = this.$(e.currentTarget);
            var qty = parseInt($button.siblings('.product_qty').val(), 10) || 1;
            this.state.quantity = qty;
            var lightFixture = lfVal || '';
            var goboSize = gsVal || '';
            this.state.lightFixture = lightFixture;
            this.state.goboSize = goboSize;
            this.render();
            
            var line = {
                item: {
                    internalid: this.model.get('internalid'),
                    itemid: this.model.get('itemid') || this.model.get('internalid')
                },
                quantity: qty,
                options: []
            };
            if (lightFixtureContainer) {
                line.options.push({
                    cartOptionId: 'custcol20',
                    value: {
                        internalid: lightFixture,
                        label: lightFixture
                    }
                });
            }
            if (goboSizeContainer) {
                line.options.push({
                    cartOptionId: 'custcol290',
                    value: {
                        internalid: goboSize
                    }
                });
            }

            // Declare the artwork option slot (with no value) whenever the
            // item has it configured, purely so ArtworkUpload.EntryPoint.js's
            // addLine guard has something to find and block on - this view
            // has no upload UI of its own, so it can never supply a value,
            // only surface that one's missing.
            if (requiresArtwork) {
                line.options.push({
                    cartOptionId: ARTWORK_CART_OPTION_ID,
                    value: null
                });
            }

            LiveOrderModel.getInstance().addLine(line).then(function () {
                self.state.isLoading = false;
                self.state.message = 'Added!';
                // Clear inputs only on successful add.
                self.state.quantity = 1;
                self.state.lightFixture = '';
                self.state.goboSize = '';
                self.render();
                
                setTimeout(function() {
                    if (self.state.message === 'Added!') {
                        self.state.message = '';
                        self.render();
                    }
                }, 2000);
            }).fail(function (jqXhr) {
                self.state.isLoading = false;
                var errorMsg = 'Error';
                
                if (jqXhr && jqXhr.responseJSON) {
                    if (jqXhr.responseJSON.errorMessage) {
                        errorMsg = jqXhr.responseJSON.errorMessage;
                    } else if (jqXhr.responseJSON.errorDetails && jqXhr.responseJSON.errorDetails.length > 0) {
                        errorMsg = jqXhr.responseJSON.errorDetails[0].message;
                    }
                }
                
                self.state.message = errorMsg;
                self.render();
            });
        },

        isItemAvailable: function () {
            if (!this.model) return false;
            
            // Verify item is available to purchase
            var isInactive = this.model.get('isinactive');
            var isBackorderable = this.model.get('isbackorderable');
            var quantityAvailable = this.model.get('quantityavailable') || 0;

            return !isInactive && (quantityAvailable > 0 || isBackorderable);
        },

        getContext: function () {
            var isAvailable = this.isItemAvailable();
            var requiresArtwork = this.hasArtworkOption();
            var selectedGoboSize = this.state.goboSize;
            var productGoboSizes = (this.model.get('options') || []).reduce(function (acc, option) {
                if (!option || !option.attributes) return acc;
                if (option.attributes.cartOptionId !== 'custcol290') return acc;
                var vals = option.attributes.values || [];
                if (!Array.isArray(vals) && typeof vals === 'object') {
                    vals = Object.values(vals);
                }
                var normalized = vals.map(function (val) {
                    var internalid = val && val.internalid ? val.internalid.toString() : '';
                    return _.extend({}, val, {
                        isSelected: !!(selectedGoboSize && internalid === selectedGoboSize)
                    });
                }).filter(function (val) {
                    return val.internalid && val.internalid.trim() !== '';
                });
                return acc.concat(normalized);
            }, []);
            var hasGoboSize = !!this.model.get('options').find(option => option.attributes.cartOptionId === 'custcol290');
            var hasLightFixture = !!this.model.get('options').find(option => option.attributes.cartOptionId === 'custcol20');
            return {
                isLoading: this.state.isLoading,
                isDisabled: this.state.isLoading || !isAvailable || requiresArtwork,
                quantity: this.state.quantity,
                message: this.state.message,
                errorMessage: this.state.errorMessage,
                isAvailable: isAvailable,
                item: this.model ? this.model.toJSON() : {},
                hasGoboSize: hasGoboSize,
                hasLightFixture: hasLightFixture,
                requiresArtwork: requiresArtwork,
                productUrl: this.model ? this.model.get('_url') : '',
                productGoboSizes: productGoboSizes,
                lightFixture: this.state.lightFixture,
                errorFields: this.state.errorFields
            };
        }
    });
});
